import api from "@/services/api/Api.js";

export default {
	update(data) {
		return api().put("/me/app-sounds-options", data);
	},
};
